import { render, staticRenderFns } from "./DeliveryNotesTable.vue?vue&type=template&id=4da7a24a&scoped=true&"
import script from "./DeliveryNotesTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesTable.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotesTable.vue?vue&type=style&index=0&id=4da7a24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7a24a",
  null
  
)

export default component.exports